import { useState, useEffect } from "react";
import { Initials } from "./components/Initials";
import { MenuList } from "../MenuList";

import { useUserToken } from "../../../../hooks/core/UserToken";
import { useUserInitials } from "../../../../hooks/utils/UserInitials";
import { useNavigate } from "react-router-dom";
import { loginManagement } from "../../../../hooks/api/LoginManagement";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { roles } from "../../../../services/utils/Roles";

const MenuFooter = ({ onMenuItemClick }) => {
    const { t } = useTranslation("common");
    const [fullName, setFullName] = useState('');
    const [avatar, setAvatar] = useState('');
    const [role, setRole] = useState('');
    const [initials, setInitials] = useState('');
    const [userToken] = useUserToken();
    const [userInitials] = useUserInitials();
    const { useForgotPasswordMutation } = loginManagement;
    const [forgotPassword] = useForgotPasswordMutation();
    const [username, setUsername] = useState("");
    const [{ getDecoded }] = useUserToken();
    const decodedToken = getDecoded();

    const dropdownList = () => {
        switch (true) {
            case decodedToken?.roles.includes(roles.SUPER_ADMIN) || decodedToken?.roles.includes(roles.PROFESSOR) || decodedToken?.roles.includes(roles.SECRETARY) || decodedToken?.roles.includes(roles.DIRECTOR) || decodedToken?.roles.includes(roles.DIRECTOR_OF_STUDIES):
                return [
                    { label: t("profile.title"), icon: "fa-light fa-user", onClick: () => goToEditProfile() },
                    { label: t("resetPassword"), icon: "fa-light fa-key", onClick: () => onResetPassword() },
                    { label: t("logOut"), href: "#", icon: "fa-light fa-right-from-bracket", onClick: () => handleLogout() },
                ]; 
            default:
                return [
                    { label: t("resetPassword"), icon: "fa-light fa-key", onClick: () => onResetPassword() },
                    { label: t("logOut"), href: "#", icon: "fa-light fa-right-from-bracket", onClick: () => handleLogout() },
                ]; 
        }
    };

    const [showDropdown, setShowDropdown] = useState(false);
    const navigate = useNavigate();

    const goToEditProfile = () => {
        navigate('/profile');
    }

    const onResetPassword = () => {
        forgotPassword({username}).then((result) => {
            if (result?.data?.info) {
                toast.info(result?.data?.info?.responseMessage);
            }
        });
    }

    const handleLogout = () => {
        userToken.removeToken();
        localStorage.removeItem("studentsFilters");
        localStorage.removeItem("callsFilters");
        localStorage.removeItem("employeesFilters");
        localStorage.removeItem("groupsFilters");
        localStorage.removeItem("testsFilters");
        localStorage.removeItem("weeklyReportsFilters");
        localStorage.removeItem("settingsGroupPlansFilters");
        navigate("/sign-up/login");
    };

    const toggleDropdown = () => {
        setShowDropdown((prev) => !prev);
    };
    
    useEffect(() => {
        const user = userToken.getDecoded();
        setUsername(user.username);
        setFullName(user.firstName + ' ' + user.lastName);
        setAvatar(user.avatar);
        setRole(user.role);
        setInitials(userInitials.getOne(user.firstName, user.lastName));
    }, []);

    return (
        <div className={`side-menu__footer side-menu__item ${showDropdown ? "side-menu__item--active" : ""}`}>
        <MenuList className="side-menu__item-dropdown" type="dropdown" list={dropdownList()} showDropdown={showDropdown} onMenuItemClick={onMenuItemClick} />
        <div className="side-menu__user-profile">
                <div className="side-menu__user-icon">
                    <div className="side-menu__user-image">
                        <i className="fa-light fa-user"></i>
                            {avatar && avatar.trim() !== "" ? (
                                <img src={avatar} alt="Profile" />
                            ) : (
                                <div className="notification-popup__user-image-initials">
                                    <Initials initials={initials}></Initials>
                                </div>
                            )}
                    </div>
                    <div className="side-menu__user-status"></div>
                </div>
                <div className="side-menu__user-text">
                    <div className="side-menu__user-name">{fullName}</div>
                    <div className="side-menu__user-role">{role}</div>
                </div>
                <button id="btnDropDown" className="btn-dropdown" onClick={toggleDropdown}>
                    <i className="fa-light fa-ellipsis-vertical"></i>
                </button>
            </div>
        </div>
    );
};

export default MenuFooter;
